import React from 'react';

interface FormTitleProps {
  title?: React.ReactNode;
  tooltip?: string;
}

export const FormTitle = ({ title, tooltip }: FormTitleProps) => {
  const tooltipText = typeof title === 'string' ? title : (tooltip ?? '');

  return (
    <>
      {title && (
        <h2
          className="mb-2 flex-auto overflow-hidden overflow-ellipsis whitespace-nowrap text-2xl font-bold text-mono-0"
          title={tooltipText}
        >
          {title}
        </h2>
      )}
    </>
  );
};
